class CartButton extends HTMLElement {
	constructor() {
		super();
		this.button = this;
		this.countElem = this.querySelector(".cart-count");

		this.init();
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		document.addEventListener('cart:updated', (event) => this.handleCartUpdate(event.detail));
	}

	handleCartUpdate(cart) {
		this.countElem.style.display = cart.item_count ? 'block' : 'none';
		this.countElem.textContent = cart.items.reduce((total, item) => total + item.quantity, 0);
	}
}

// Register the custom element
customElements.define('cart-button', CartButton);